import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import "./style.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReviewForm from "./routes/ReviewForm";
import MedicalRecordsUpload from "./routes/MedicalRecordsUpload";
import TermsAndConditions from "./routes/TermsAndConditions";
import CheckoutForm from './CheckoutForm';
import ThankYou from "./routes/ThankYou";
import Sponsor from "./routes/Sponsor";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_live_51HS1R2ES4QdrazEvCumLKFAFHwHCNcJEMJ7JaiL4KZPgtppi2QbrCAHS3xZ6TbZO2ywcxBoyElzgSOEYFfpa5OLP00MT7xgoKN');

function App() {
  const [clientSecret, setClientSecret] = useState('');
  const [options, setOptions] = useState();

  useEffect(() => {
    console.log("Mounted");
    (async () => {
      const response = await fetch('https://1u18v9pmx3.execute-api.us-west-2.amazonaws.com/prod/');
      const { client_secret: clientSecret } = await response.json();

      setClientSecret(clientSecret);
      const appearance = {
        theme: 'stripe',
      };

      setOptions({ clientSecret, appearance });
    })();
  }, []);

  if (!options) {
    return <progress className="progress is-small is-primary" max="100">15%</progress>;
  } else {
    return (
      <React.StrictMode>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ReviewForm />}></Route>
            <Route
              path="/medical-records-upload"
              element={<MedicalRecordsUpload />}
            ></Route>
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            ></Route>
            <Route path="/sponsor" element={<Sponsor />}>
            </Route>
            <Route path="/checkout" element={
              <Elements stripe={stripePromise} options={options}>
                <CheckoutForm />
              </Elements>}>
            </Route>
            <Route path="/thank-you" element={<ThankYou />}></Route>
          </Routes>
        </BrowserRouter>
      </React.StrictMode>
    )
  }
}

ReactDOM.render(<App />, document.getElementById('root'));


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
